import React from 'react';
import ReactPlayer from 'react-player';
import Html from '@components/common/Html';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { TUTORIAL_MENU_TYPE, tutorialMenuMap } from '@domain/constant/acca/tutorial/tutorialMenuType';
import { GameType, gameTypeStringMap } from '@domain/constant/acca/test/result/gameType';
import classnames from 'classnames/bind';
import styles from './gameInfo.module.scss';

const cx = classnames.bind(styles);

interface GameInfoProps {
  menu: TUTORIAL_MENU_TYPE;
  gameTab: GameType;
}

const GameInfo = ({ menu, gameTab }: GameInfoProps) => {
  const { accaResultStore } = useResultStore();
  const { accGameResult } = accaResultStore;

  const detail = accGameResult?.details?.find((detail) => {
    if (detail.type === gameTab) return detail;
  });

  const tab = tutorialMenuMap[menu].tabList.find((tab) => {
    return tab.type === gameTab;
  });

  if (!tab || !detail) return null;

  const { type, description } = detail;
  const viewDescription = description.replace(/\\n/g, '<br>');
  const { url } = tab;

  return (
    <div className={cx('infoArea')}>
      <div className={cx('videoWrap')}>
        <ReactPlayer url={url} muted={true} loop={true} playing={true} width={'100%'} height={'100%'} />
      </div>

      <div className={cx('infoWrap')}>
        <div className={cx('infoTitleArea')}>
          <strong className={cx('infoTitle')}>{gameTypeStringMap[type]}</strong>
        </div>
        <Html as="p" className={cx('infoText')} html={viewDescription} />
      </div>
    </div>
  );
};

export default GameInfo;
